// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5411":"5859fd04","5461":"eeb80655","7639":"717cf1ea"}[chunkId] + ".chunk.css";
};